import { useParams } from "react-router-dom";
import { Box, HStack, VStack } from "@chakra-ui/react";
import { IoIosSend } from "react-icons/all";

import { useGetResetPasswordEmail } from "modules/user/infrastructure/useGetResetPasswordEmail";
import { ResetPasswordForm } from "modules/user/presentation/ResetPasswordForm";

import { ChakraText } from "components/ChakraText";
import { DetailFrame } from "components/DetailFrame";
import { UndrawImage } from "components/UndrawImage";

import { TokenExpiredErrorBoundary } from "../Commons/TokenExpiredErrorBoundary";

import forgot_password from "../../../assets/undraw_forgot_password.svg";
import forgot_password_dark from "../../../assets/undraw_forgot_password_dark.svg";

const ResetPasswordPageThrowable = () => {
  const { tokenId } = useParams<{
    tokenId: string;
  }>();

  const { data } = useGetResetPasswordEmail(tokenId);

  return (
    <HStack w="90%" m="auto">
      <Box w={{ sm: "100%", lg: "50%" }}>
        <VStack spacing={4} maxW="400px" mx="auto">
          <ChakraText fontSize="lg">Reset hasła</ChakraText>
          {data?.email && (
            <DetailFrame icon={IoIosSend}>
              <ChakraText textAlign="center">{data.email}</ChakraText>
            </DetailFrame>
          )}
          <ResetPasswordForm tokenId={tokenId} />
        </VStack>
      </Box>

      <Box
        w="50%"
        display={{ sm: "none", lg: "flex" }}
        m="auto"
        h="500px"
        alignItems="center"
      >
        <UndrawImage
          lightImage={forgot_password}
          darkImage={forgot_password_dark}
          alt="Zapomniane hasło"
        />
      </Box>
    </HStack>
  );
};

const ResetPasswordPage = () => {
  return (
    <TokenExpiredErrorBoundary>
      <ResetPasswordPageThrowable />
    </TokenExpiredErrorBoundary>
  );
};

export default ResetPasswordPage;
